<template>
	<div>
		<validation-observer ref="observer" v-slot="{ handleSubmit }">
			<b-form v-on:submit.stop.prevent="handleSubmit( onSubmit )">
				<b-form-row>
					<b-col md="7">
						<validation-provider v-slot="validationContext" name="Product Description" v-bind:rules="{ required: true }" vid="description">
							<b-form-input id="product-description" v-model="product.description" placeholder="Product Description" v-bind:state="getValidationState( validationContext )"></b-form-input>
							<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
						</validation-provider>
					</b-col>
					<b-col md="3">
						<validation-provider v-slot="validationContext" name="Product Quantity" v-bind:rules="{ required: true, min_value: 1 }" vid="quantity">
							<b-form-input id="product-quantity" v-model.number="product.quantity" placeholder="##" type="number" v-bind:state="getValidationState( validationContext )"></b-form-input>
							<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
						</validation-provider>
					</b-col>
					<b-col md="2">
						<b-button :disabled="project.locked" block type="submit" variant="light">Add</b-button>
					</b-col>
				</b-form-row>
				<b-form-row>
					<b-col class="mt-2" md="10">
						<validation-provider v-slot="validationContext" name="Supplier" v-bind:rules="{ required: true }" vid="supplier">
							<b-form-group ref="product-supplier" label-for="product-supplier">
								<autocomplete id="product-supplier" v-model="product.supplier" endpoint="/suppliers/search/{token}" label-key="name" place-holder="Supplier" v-bind:validation-context="validationContext"></autocomplete>
							</b-form-group>
						</validation-provider>
					</b-col>
				</b-form-row>
			</b-form>
		</validation-observer>
		<hr class="bg-primary"/>
		<b-list-group>
			<b-list-group-item>
				<h4 class="text-right"><strong>Total:</strong> {{ total }}</h4>
			</b-list-group-item>
			<b-list-group-item v-for="n in products" :key="n.id" class="pl-0 pr-0">
				<product-tile :value="n"></product-tile>
			</b-list-group-item>
		</b-list-group>

	</div>
</template>

<script>
import { PROJECT_PRODUCTS_ADD, PROJECT_PRODUCTS_FETCH } from '../../store/actions/project'
import ProductTile from '../../components/ProductTile'
import Autocomplete from '../../components/Autocomplete'

export default {
	name: 'ProjectProducts',

	props: ['id'],

	components: {
		ProductTile,
		Autocomplete
	},

	computed: {
		project: function () { return this.$store.state.project.project },
		products: function () { return this.$store.state.project.products },
		total: function () { return Intl.NumberFormat().format(this.products.reduce((a, b) => a + b.quantity, 0)) }
	},

	data () {
		return {
			product: {
				description: '',
				quantity: 0,
				supplier: null
			}
		}
	},

	methods: {
		getValidationState ({ dirty, validated, valid = null }) {
			return dirty || validated ? valid : null
		},

		async onSubmit () {
			console.log( this.products.reduce((a, b) => a.quantity + b.quantity, 0) );
			this.$refs['observer'].reset()
			this.product.project = JSON.parse(JSON.stringify(this.project))

			this.$axios.post(`/products`, this.product)
				.then(response => {
					this.product.description = ''
					this.product.quantity = 0
					this.product.project = null
					this.product.supplier = null
					this.$store.commit(PROJECT_PRODUCTS_ADD, response.data)
				})
		},

		fetchProducts () {
			this.$store.dispatch(PROJECT_PRODUCTS_FETCH, this.project.id)
		}
	},

	mounted () {
		if (this.project.id) {
			this.fetchProducts()
		}
	},

	watch: {
		project: function () { this.fetchProducts(); }
	}
}
</script>
